/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_Issue_Duplicate_FileInputs */

const en_claim_issue_duplicate_file = /** @type {(inputs: Claim_Issue_Duplicate_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The same file is named twice.`)
};

/**
* | output |
* | --- |
* | "The same file is named twice." |
*
* @param {Claim_Issue_Duplicate_FileInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const claim_issue_duplicate_file = /** @type {((inputs?: Claim_Issue_Duplicate_FileInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Issue_Duplicate_FileInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_claim_issue_duplicate_file(inputs)
});